type Props = {
  /** Label such as "v1", "v1.1", "v2". When empty, renders nothing. */
  label: string;
};

/** The blue-outlined version pill shown on Workflows cards next to the title. */
export function VersionChip({ label }: Props) {
  if (!label) return null;
  return (
    <span
      style={{
        flexShrink: 0,
        border: '1px solid #0075be',
        // Text a step darker than the border: BMO blue #0075be on this tint is
        // 4.48:1, two hundredths under the 4.5:1 this 12px text needs
        // (WCAG 1.4.3). The border keeps the brand blue, so the pill reads the
        // same. #0070b5 -> 4.82:1.
        color: '#0070b5',
        background: '#eef6fb',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        padding: '1px 9px',
        lineHeight: '18px',
      }}
    >
      {label}
    </span>
  );
}
